<template>
<div>
    <table class="table table-dark table-striped table-hover" v-if="StockList.length>0">
      <thead>
          <tr>
          <th scope="col">#</th>
          <th scope="col">Stock Code</th>
          <th scope="col">Description</th> 
          </tr>
      </thead>
      <tbody>
          <tr class="CanClick" v-for="(row,index) in StockList" :key="row.StockCode" @click="selectStockCode(row)">
          <th scope="row">{{index}}</th>
          <td>{{row.StockCode}}</td>
          <td>{{row.Description}}</td> 
          </tr> 
      </tbody>
      </table>
      

</div>
</template>

<script>
export default {
    emits: ["Select"],
    props: { StockList: Array},
    methods:{
    selectStockCode(row) {
        
        this.$emit("Select", row);
        
    }
  }
}
</script>

<style>
.CanClick{
    cursor: pointer;
}
</style>